import React from "react";
import { ExternalLink } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSeo } from "@/lib/api";
import { Section, Reveal } from "@/components/common/Section";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getLegalContent } from "@/data/legal";

export default function Legal({ type }) {
  const { t, lang } = useLang();
  const content = getLegalContent(type, lang);
  const pathMap = {
    mentions: "/mentions-legales",
    privacy: "/politique-confidentialite",
    cookies: "/politique-cookies",
    complaints: "/reclamations",
  };
  useSeo({ lang, path: pathMap[type], title: `${content.title} — NEKASSUR`, description: content.intro });
  const missingLabel = t.legalCommon.toComplete;

  return (
    <>
      <section className="bg-nek-navy">
        <div className="nek-container py-12 sm:py-16">
          <Breadcrumb onDark items={[{ label: content.title }]} />
          <Reveal className="mt-8 max-w-3xl">
            <h1 className="nek-h1 text-white" style={{ fontSize: "clamp(2rem,3.6vw,3rem)" }}>{content.title}</h1>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-white/70">{content.intro}</p>
          </Reveal>
        </div>
      </section>

      <Section tone="white">
        <div className="mx-auto max-w-3xl">
          {content.table && (
            <div className="overflow-hidden rounded-2xl border border-nek-border" data-testid="legal-identity-table">
              <table className="w-full text-sm">
                <tbody className="divide-y divide-nek-border">
                  {content.table.map((row, i) => (
                    <tr key={row.label} className={i % 2 ? "bg-nek-light" : "bg-white"}>
                      <th scope="row" className="w-2/5 px-5 py-3.5 text-left font-semibold text-nek-navy align-top">{row.label}</th>
                      <td className="px-5 py-3.5 text-nek-ink">
                        {row.link ? (
                          <span className="inline-flex items-center gap-2">{row.value}<a href={row.link} target="_blank" rel="noopener noreferrer" className="text-nek-teal"><ExternalLink className="h-3.5 w-3.5" /></a></span>
                        ) : (
                          row.value
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="mt-10 space-y-8">
            {content.sections?.map((s, i) => (
              <Reveal as="div" key={s.h}>
                <h2 className="text-xl font-heading font-bold text-nek-navy">{s.h}</h2>
                <p className="mt-2 leading-relaxed text-nek-gray">{s.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </Section>
    </>
  );
}
